// extracted by mini-css-extract-plugin
module.exports = {"dp3-crowdfunding-bundle":"NA_dp3-crowdfunding-bundle__yJCjU","tooltips":"NA_tooltips__s6U5f"};